import React, { useContext, useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import Header from './components/header/Header';
import './CustomerRoute.scss';
import Footer from './components/footer/Footer';
import MobileHeader from './components/header/MobileHeader';
import { useAuth } from '../../contexts/userContext/userContext';
import LinksChain from './components/LinksChain';
import NavigationDrawer from '../components/drawers/navigationDrawer/NavigationDrawer';
import Authorization from '../components/globalActions/Authorization';
import Registration from '../components/globalActions/Registration';
import { TranslationContext } from '../../contexts/TranslationContext';
import PasswordRecovery from '../components/globalActions/PasswordRecovery';
import MobileNavigation from './components/MobileNavigation';
import ProfileNavigationDrawer
  from '../components/drawers/profileNavigationDrawer/ProfileNavigationDrawer';
import ScrollToTop from '../components/globalActions/ScrollToTop';
import ErrorMessageModal from '../components/modals/errorMessageModal/ErrorMessageModal';
import useTranslation from '../../hooks/translation/useTranslation';
import { localesWithFlags } from '../../../utils/constants/locales';

function CustomerRoute() {
  const { configInfo } = useTranslation();
  const { lang } = useParams();
  const { setCurrentLanguage } = useContext(TranslationContext);
  const navigate = useNavigate();
  const isGeorgia = configInfo?.countryCode === 'GE';

  useEffect(() => {
    if (localesWithFlags.find(
      (l) => l.code === lang && l.allowedCountries.includes(configInfo?.countryCode),
    )) {
      document.documentElement.lang = lang;
      setCurrentLanguage(lang);
    } else {
      navigate((isGeorgia ? '/ka' : '/am'));
    }
  }, [lang]);

  const {
    accessToken, getCurrentUser,
  } = useAuth();

  useEffect(() => {
    getCurrentUser();
  }, [accessToken]);

  return (
    <div
      className={`flex flex-col gap-[120px] bg-green min-h-screen items-center relative bg-gray-light-gr overflow-x-clip 
      ${isGeorgia ? 'customer-route' : 'am-customer-route'}
      `}
    >
      <Header />
      <MobileHeader />
      <main className="container grow mobile-padding">
        <LinksChain />
        <Outlet />
      </main>
      <MobileNavigation />
      <Footer />
      <Authorization />
      <PasswordRecovery />
      <Registration />
      <NavigationDrawer />
      <ProfileNavigationDrawer />
      <ErrorMessageModal />
      <ScrollToTop />
    </div>
  );
}

export default CustomerRoute;
